import { render, staticRenderFns } from "./simplifyRoomFee.vue?vue&type=template&id=d72936b4&scoped=true"
import script from "./simplifyRoomFee.vue?vue&type=script&lang=js"
export * from "./simplifyRoomFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyRoomFee.vue?vue&type=style&index=0&id=d72936b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72936b4",
  null
  
)

export default component.exports